import mpx from '../index'

export default mpx
